export const NODE_RAN_MULTIPLE_TIMES_WARNING =
	"This node ran multiple times - once for each input item. You can change this by setting 'execute once' in the node settings. <a href='https://docs.n8n.io/flow-logic/looping/#executing-nodes-once' target='_blank'>More Info</a>";

export const LOCALHOST = '127.0.0.1';

export const ENABLE_LESS_STRICT_TYPE_VALIDATION =
	"Try changing the type of comparison. Alternatively you can enable 'Convert types where required'.";
